<template>
    <div class="public_container customer_add_wrap" v-loading="loading">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true" :isCustomReturnEvent="true" @returnEvent="handleClickReturnRouter">

            </ReturnNavBar>
        </div>
        <div class="mobile_container">
            <CustomFormMobile
                ref="crm_custom_form"
                :field_list="formInfoList"
                :form_detail="formData"
                :is_form_module="true"
                @submit-form="submitFormData"
                :pk_id="pk_id"
                v-if="dataLoaded"
            />
        </div>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">确定</van-button>
        </div>
    </div>
</template>

<script>
import {EventBus} from '@/utils/eventBus';
import {removeTag} from "@/utils";
import {
    getFormFields,
    CustomerPrivateEdit,
    CustomerPublicEdit,
    GetCustomerPublicDetail,
    GetCustomerPrivateDetail,
} from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import CustomFormMobile from "@/components/mComponents/CustomFormMobile";
export default {
    name: "MCustomerEdit",
    components: { ReturnNavBar, CustomFormMobile },
    data() {
        return {
            addType: this.$route.query && this.$route.query.addType, // 新增类型 public：公海，private：私海
            sea_id: this.$route.query && this.$route.query.sea_id, // 公海id
            editId: this.$route.query && this.$route.query.id, // 编辑id
            loading: false,
            formInfoList: [],
            formData: {},
            pk_id: this.editId ? Number(this.editId) : 0,
            dataLoaded: false,
            btnDisabled: false,
        };
    },
    created() {
        this._getFromFields();
    },
    methods: {
        handleClickReturnRouter() {
            removeTag(this.$route)
            this.$router.go(-1);
        },
        //表单字段获取
        _getFromFields() {
            this.loading = true;
            getFormFields({
                field_form: "customers",
            }).then((res) => {
                if (res.code === 200) {
                    this.formInfoList = res.data;
                    if (this.editId) {
                        if (this.addType === "public") {
                            // 公海
                            GetCustomerPublicDetail(this.editId).then((res) => {
                                if (res.code === 200) {
                                    this.formData = res.data || {};
                                    this.loading = false;
                                    this.dataLoaded = true;
                                }
                            });
                        } else {
                            // 私海
                            GetCustomerPrivateDetail(this.editId).then((res) => {
                                if (res.code === 200) {
                                    this.formData = res.data || {};
                                    this.loading = false;
                                    this.dataLoaded = true;
                                }
                            });
                        }
                    }
                }
            });
        },
        handleClickConfirm() {
            this.$refs.crm_custom_form.handleClickPublish();
        },
        submitFormData(customForm) {
            if (customForm) {
                if (this.addType === "public") {
                    // 公海
                    CustomerPublicEdit(this.editId, customForm)
                        .then((res) => {
                            if (res.code == 200) {
                                this.$toast({
                                    message: res.message,
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        removeTag(this.$route);
                                        EventBus.$emit('customerEditUpdated');
                                        this.$router.go(-1);
                                    },
                                });
                            }
                            this.btnDisabled = false;
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                        });
                } else {
                    CustomerPrivateEdit(this.editId, customForm)
                        .then((res) => {
                            if (res.code == 200) {
                                this.$toast({
                                    message: res.message,
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        removeTag(this.$route);
                                        EventBus.$emit('customerEditUpdated');
                                        this.$router.go(-1);
                                    },
                                });
                            }
                            this.btnDisabled = false;
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                        });
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.customer_add_wrap {
    .mobile_container {
        padding: 10px 0;
    }
    .add_footer_wrap {
        padding: 5px 16px;
        background-color: #f7f8fa;

        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(41, 144, 240, 1);
            border-color: rgba(41, 144, 240, 1);
        }
    }
}
</style>
